import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import templateQuestions from 'modules/surveys/store/collections/templateQuestions'
import type TemplateQuestion from 'modules/surveys/store/models/TemplateQuestion'

class QuestionsTemplateCategory extends Model {
  static urlRoot() {
    return '/surveys/questions_template_categories'
  }

  constructor(attr = {}) {
    super(attr)
    makeObservable(this, {
      name: computed,
      templateQuestions: computed,
    })
  }

  get name() {
    return this.attributes.name
  }

  get templateQuestions(): TemplateQuestion[] {
    return templateQuestions.filter({
      surveys_questions_template_category_id: this.attributes.id,
    })
  }
}

export default QuestionsTemplateCategory
